import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CompanyProductDeploy } from 'src/app/models/company_product_deploy.model';
import { ApiService } from 'src/app/services/api.service';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DatePipe, CommonModule } from '@angular/common';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'app-company-product-deploy-detail',
  templateUrl: './company-product-deploy-detail.component.html',
  styleUrls: ['./company-product-deploy-detail.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterLink, MatIcon, MatButton, DatePipe, MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatChipsModule],
})
export class CompanyProductDeployDetailComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private api = inject(ApiService);
  private router = inject(Router);

  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  deploy: CompanyProductDeploy | null = null;
  deploy_id: string;

  constructor() {
    this.deploy_id = this.activatedRoute.snapshot.paramMap.get('id') as string;
  }

  ngOnInit(): void {
    this.fetchDeploy();
  }

  getStatusLabel(status: string): string {
    const labels: { [key: string]: string } = {
      pending: 'Pendiente',
      running: 'En ejecución',
      success: 'Exitoso',
      failure: 'Fallido',
      cancelled: 'Cancelado',
    };
    return labels[status] || status;
  }

  getStatusChipClass(status: string): string {
    const classes: { [key: string]: string } = {
      pending: 'mat-yellow',
      running: 'mat-accent',
      success: 'mat-success',
      failure: 'mat-warn',
      cancelled: 'mat-grey',
    };
    return classes[status] || 'mat-grey';
  }

  getGithubUrl(): string {
    if (this.deploy?.github_events && this.deploy.github_events.length > 0) {
      const firstEvent = this.deploy.github_events[0];
      return firstEvent?.payload?.workflow_run?.html_url || '#';
    }
    return '#';
  }

  private fetchDeploy() {
    this.api
      .getCompanyProductDeploy(this.deploy_id, {
        with: 'application_environment,user,product_tasks,github_events,company_product,application_environment.application',
      })
      .subscribe(data => {
        this.deploy = data;
      });
  }
}
